<template>
  <div class="card">
    <div class="section">
      <div class="section-title">
        <base-section-title :title="isEntrust ? '代理采购项目' : '采购情况'" />
      </div>
      <div class="section-content">
        <div class="m-b-20">
          <el-radio-group v-model="activeType">
            <el-radio
              v-for="item in purchaseTypeList"
              :key="item.value"
              size="medium"
              class="m-r-20"
              border
              :label="item.value"
            >
              {{ item.label }}({{ projectInfo[item.alias] || 0 }})
            </el-radio>
          </el-radio-group>
        </div>

        <div>
          <bidding-table
            v-show="activeType === purchaseTypeDict.BIDDING.value"
            ref="biddingTable"
            :project-id="projectId"
            :is-entrust="isEntrust"
          />
          <bidding-record-table
            v-show="activeType === purchaseAllTypeDict.BIDDING_RECORD.value"
            ref="biddingRecordTable"
            :project-id="projectId"
            :is-entrust="isEntrust"
          />
          <inquiry-table
            v-show="activeType === purchaseTypeDict.INQUIRY.value"
            ref="inquiryTable"
            :project-id="projectId"
            :is-entrust="isEntrust"
          />
          <compete-table
            v-show="activeType === purchaseTypeDict.COMPETE.value"
            ref="competeTable"
            :project-id="projectId"
            :is-entrust="isEntrust"
          />
          <negotiation-table
            v-show="activeType === purchaseTypeDict.NEGOTIATION.value"
            ref="negotiationTable"
            :project-id="projectId"
            :is-entrust="isEntrust"
          />
          <direct-purchase-table
            v-show="activeType === purchaseAllTypeDict.DIRECT_PURCHASE.value"
            ref="directPurchaseTable"
            :project-id="projectId"
            :is-entrust="isEntrust"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import BiddingTable from '@/components/register/BiddingTable'
import BiddingRecordTable from '@/components/register/BiddingRecordTable.vue'
import InquiryTable from '@/components/register/InquiryTable'
import CompeteTable from '@/components/register/CompeteTable'
import NegotiationTable from '@/components/register/NegotiationTable'
import DirectPurchaseTable from '@/components/register/DirectPurchaseTable'

import {
  purchaseTypeDict,
  purchaseAllTypeDict
} from '@/dictionary/project/common'

export default {
  components: {
    BaseSectionTitle,
    BiddingTable,
    BiddingRecordTable,
    InquiryTable,
    CompeteTable,
    NegotiationTable,
    DirectPurchaseTable
  },

  props: {
    // 是否是委托采购
    isEntrust: {
      type: Boolean,
      default: false
    },

    // 统计数字信息
    projectInfo: {
      type: Object,
      default: () => {
        return {
          projectName: '',
          [purchaseTypeDict.BIDDING.alias]: 0,
          [purchaseAllTypeDict.BIDDING_RECORD.alias]: 0,
          [purchaseTypeDict.INQUIRY.alias]: 0,
          [purchaseTypeDict.COMPETE.alias]: 0,
          [purchaseTypeDict.NEGOTIATION.alias]: 0,
          [purchaseAllTypeDict.DIRECT_PURCHASE.alias]: 0
        }
      }
    },

    projectId: {
      type: [String, Number],
      default: 0
    }
  },

  data() {
    return {
      purchaseTypeDict,
      purchaseAllTypeDict,

      activeType: purchaseTypeDict.BIDDING.value
    }
  },

  computed: {
    purchaseTypeList() {
      return [
        purchaseTypeDict.BIDDING,
        this.isEntrust
          ? undefined
          : { ...purchaseAllTypeDict.BIDDING_RECORD, label: '备案采购' },
        purchaseTypeDict.INQUIRY,
        purchaseTypeDict.COMPETE,
        purchaseTypeDict.NEGOTIATION,
        this.isEntrust ? undefined : purchaseAllTypeDict.DIRECT_PURCHASE
      ].filter(value => value)
    }
  },

  methods: {
    getInfo() {
      this.$refs.biddingTable.getList()
      this.$refs.biddingRecordTable.getList()
      this.$refs.inquiryTable.getList()
      this.$refs.competeTable.getList()
      this.$refs.negotiationTable.getList()
      this.$refs.directPurchaseTable.getList()
    }
  }
}
</script>

<style lang="scss" scoped></style>
